import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

import store from "./redux/store";
import { Provider } from "react-redux";
import { SnackbarProvider } from "./snackbarContext";
import { DuePaymentsProvider } from "./context/DuePaymentsContext";
import { AnalyticsOverviewProvider } from "./context/AnalyticsOverviewContext";
ReactDOM.render(
  <Provider store={store}>
    <React.Fragment>
      <SnackbarProvider>
        <DuePaymentsProvider>
          <AnalyticsOverviewProvider>
            <App />
          </AnalyticsOverviewProvider>
        </DuePaymentsProvider>
      </SnackbarProvider>
    </React.Fragment>
  </Provider>,
  document.getElementById("root")
);

reportWebVitals();
